/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OnboardingAccess } from '../../models/onboarding-access';

export interface GetAllOnboardingServiceAccess$Params {

/**
 * The user uid
 */
  userUid: string;
}

export function getAllOnboardingServiceAccess(http: HttpClient, rootUrl: string, params: GetAllOnboardingServiceAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingAccess>>> {
  const rb = new RequestBuilder(rootUrl, getAllOnboardingServiceAccess.PATH, 'get');
  if (params) {
    rb.path('userUid', params.userUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OnboardingAccess>>;
    })
  );
}

getAllOnboardingServiceAccess.PATH = '/custom/onboarding/user/{userUid}/service';
